/* global gtag */

import { createRouter, createWebHistory } from "vue-router";
import store from "../store";

const routes = [
  {
    path: "/",
    name: "layout",
    redirect: "/Home",
    component: () => import("../views/Layout/LayoutIndex.vue"),
    meta: {
      title: "BeArt | Welcome",
    },
    children: [
      {
        path: "/Home",
        name: "Home",
        component: () => import("../views/NewHome/Home-parent.vue"),
        meta: {
          title: "BeArt | Welcome",
        },
        children: [
          {
            path: "",
            name: "main",
            component: () => import("../views/NewHome/index.vue"),
            meta: {
              parent: "Home",
            },
          },

          {
            path: "play",
            name: "play",
            component: () => import("../views/Play/index.vue"),
            meta: {
              parent: "Home",
            },
          },
        ],
      },

      {
        path: "/Purchase",
        name: "Purchase",
        component: () => import("../views/Purchase/PurchaseIndex/index.vue"),
        meta: {
          title: "BeArt | Purchase",
        },
      },
      {
        path: "/AssetsToken",
        name: "AssetsToken",
        component: () => import("../views/Purchase/AssetsToken/index.vue"),
        meta: {
          title: "BeArt | Purchase",
          parent: "Purchase",
        },
      },
      {
        path: "/Disposal",
        name: "Disposal",
        component: () => import("../views/Purchase/Disposal/disposalIndex.vue"),
        meta: {
          title: "BeArt | Purchase",
          parent: "Purchase",
        },
      },
      {
        path: "/Gallery",
        name: "Gallery",
        component: () => import("../views/Gallery/galleryIndex.vue"),
        meta: {
          title: "BeArt | Gallery",
          parent: "More",
        },
      },
      {
        path: "/glory",
        name: "glory",
        component: () => import("../views/GloryView.vue"),
        meta: { title: "BeArt | Our Glory", parent: "More" },
      },
    ],
  },
  {
    path: "/Pdf",
    name: "Pdf",
    component: () => import("../views/Purchase/AssetsToken/pdf/viewPdf.vue"),
    meta: {
      title: "BeArt | pdf",
    },
  },
  {
    path: "/Leaderboard",
    name: "Leaderboard",
    component: () => import("../views/Leaderboard/index.vue"),
    meta: {
      title: "BeArt | Leaderboard",
    },
    children: [
      {
        path: "",
        name: "InvitedUser",
        component: () => import("../views/Leaderboard/views/InvitedUser.vue"),
      },
      {
        path: "taskCenter",
        name: "taskCenter",
        component: () =>
          import("../views/Leaderboard/views/TaskCenter/TaskCenter.vue"),
        meta: {
          parent: "Leaderboard",
        },
      },
    ],
  },

  {
    path: "/mobile-play/:pathxx(.*)*", //通配所有路由
    name: "Main",
    meta: {
      parent: "Home",
    },
    component: () =>
      import(/* webpackChunkName: "main" */ "../views/MobilePlay/index.vue"),
  },

  // {
  //   path: "/operation/adminlogin",
  //   name: "adminlogin",
  //   component: () => import("../views/LoginAdmin.vue"),
  //   meta: { title: "BeArt | AdminLogin" },
  // },
  // {
  //   path: "/operation/operation-management",
  //   name: "operation",
  //   component: () => import("../views/AdminOperation.vue"),
  //   meta: { title: "BeArt | OperationView", requiresAuth: true },
  // },

  // {
  //   path: "/Affiliate/Affiliate-Login",
  //   name: "Affiliatelogin",
  //   component: () => import("../views/AffiliateLogin.vue"),
  //   meta: { title: "BeArt | Affiliate-Login" },
  // },
  // {
  //   path: "/Affiliate/Dashboard",
  //   name: "AffiliateDashboard",
  //   component: () => import("../views/AffiliateDashboard.vue"),
  //   meta: { title: "BeArt | Affiliate-Dashboard", requiresAuth: true },
  // },
  /*
  {
    path: '/BvcNFT',
    name: 'BvcNFT',
    component: () => import('../views/BvcNFT/index.vue'),
    meta: { title: 'BeArt | BvcNFT' },
  },
  */
  // {
  //   path: "/worldview",
  //   name: "worldview",
  //   component: () => import("../views/WorldView.vue"),
  //   meta: { title: "BeArt | Worldview" },
  // },
  // {
  //   path: "/promotion",
  //   name: "promotion",
  //   component: () => import("../views/PromotionView.vue"),
  //   meta: { title: "BeArt | Promotions" },
  // },
  // {
  //   path: "/artverse",
  //   name: "artverse",
  //   component: () => import("../views/ArtverseView.vue"),
  //   meta: { title: "BeArt | Art.Space" },
  // },
  // {
  //   path: "/gnft",
  //   name: "gnft",
  //   component: () => import("../views/GNFTView.vue"),
  //   meta: { title: "BeArt | Genetic NFT" },
  // },

  // {
  //   path: "/mineview",
  //   name: "mineview",
  //   component: () => import("@/views/MineView.vue"),
  //   meta: { title: "BeArt | Mine" },
  // },
  // {
  //   path: "/WikiBook",
  //   name: "wikibook",
  //   component: () => import("../components/Worldview_Page/WikiBook.vue"),
  //   meta: { title: "BeArt | WikiBook" },
  // },
  // {
  //   path: "/wiki/:articleId",
  //   name: "Wiki",
  //   component: () => import("../components/Worldview_Page/WikiCenter.vue"),
  //   meta: { title: "BeArt | Wiki Center" },
  // },
  // {
  //   path: "/mintnft",
  //   name: "NFTmint",
  //   component: () => import("../components/NFTmint.vue"),
  //   meta: { title: "BeArt | Mint NFT" },
  // },
  // {
  //   path: "/Gallery_Search",
  //   name: "Gallery_Search",
  //   component: () => import("@/views/GallerySearch/index.vue"),
  //   meta: { title: "BeArt | Gallery_Search" },
  // },
  // {
  //   path: "/Artverse_Background",
  //   name: "Artverse",
  //   component: () =>
  //     import("../components/ArtSpace_Page/Artverse_Background.vue"),
  // },
  // {
  //   path: "/Art_GNFTFinal",
  //   name: "ArtGNFTFinal",
  //   component: () => import("../components/GNFTDetails_Page/Art_GNFTFinal.vue"),
  // },

  // {
  //   path: "/gnftworld/:position/:id",
  //   name: "GNFTWorld",
  //   component: () => import("../components/GNFTDetails_Page/Art_GNFTWorld.vue"),
  // },
  // {
  //   path: "/gnfttotal/:position/:id",
  //   name: "Art_GNFTTotal",
  //   component: () => import("../components/GNFTDetails_Page/Art_GNFTTotal.vue"),
  // },
  // {
  //   path: "/GNFTMicro/:position/:id",
  //   name: "GNFTMicro",
  //   component: () => import("../components/GNFTDetails_Page/Art_GNFTMicro.vue"),
  //   props: true,
  // },
  // {
  //   path: "/referral/:code",
  //   component: () => import("../components/EmptyComponent.vue"),
  // },
  // {
  //   path: "/test/wallet1",
  //   component: () => import("../components/WalletConnect.vue"),
  // },
  // {
  //   path: "/test/Testcontract",
  //   component: () => import("@/views/Test_Contract.vue"),
  // },
  /*{
    path: '/test/wallet2',
    component: () => import('../components/WalletConnect1.vue') ,
  },*/

  // {
  //   path: "/test/RWA_Auction",
  //   name: "GNFT-Gallery",
  //   component: () => import("@/views/RWA_Auction.vue"),
  //   meta: { title: "BeArt | Gallery" },
  // },
  // {
  //   path: "/test/LotsView",
  //   name: "Collection_Views",
  //   component: () => import("@/views/GNFTLotsView/index.vue"),
  //   meta: { title: "BeArt | Collection" },
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 添加全局前置守卫
router.beforeEach(async (to, from, next) => {
  const authToken = localStorage.getItem("authToken");
  if (to.matched.some((record) => record.meta.requiresAuth) && !authToken) {
    // 如果路由需要认证且用户未登录，重定向到登录页面
    next({ name: "home" });
  } else {
    /*
        // （可选）向后端发送验证 token 的请求
        axios.get('https://beart.one/data/protected', { headers: { 'Authorization': `Bearer ${authToken}` } })
        .then(() => {
          // 如果 token 有效，允许访问
        })
        .catch(() => {
          // 如果 token 无效，清除 token 并重定向到登录页面
          localStorage.removeItem('authToken');
          next({ name: 'home' });
      next();
      *
  })
*/
  }

  document.title = to.meta.title || "BeArt Web3";

  // 检查是否为邀请链接
  if (to.path.startsWith("/referral/") && to.params.code) {
    //console.log('Route path:', to.path);
    //console.log('Route params:', to.params);
    // 存储邀请码到 Vuex
    await store.dispatch("handleReferral", to.params.code);
    // 重定向到首页
    next({ path: "/promotion" });
  } else {
    // 非邀请链接的处理
    store.commit("SET_LOADING", true);
    next();
  }
});

router.afterEach((to) => {
  window.scrollTo(0, 0);
  store.commit("changRouterPath", to.fullPath);
  setTimeout(() => {
    store.commit("SET_LOADING", false); // 在导航结束后设置 isLoading 为 false
  }, 2000);
  if (typeof gtag === "function") {
    gtag("config", "G-D8CMKW9MJE", {
      page_path: to.fullPath,
      page_title: to.meta.title || document.title,
    });
  }
});

export default router;
